import { render, staticRenderFns } from "./_project_addoredit.vue?vue&type=template&id=05d796d6&"
import script from "./_project_addoredit.vue?vue&type=script&lang=js&"
export * from "./_project_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports